import { formMateriaInicial } from '../../../../objetos/objeto_materias';
import React, { useState ,useEffect} from 'react';
import { BookOpen, Tag, DollarSign, AlignLeft, CheckCircle2, AlertCircle, Plus } from 'lucide-react';
import ListaMaterias from './listaMaterias';

const AddMateria = ({ onAdd , materias }) => {
    const [formData, setFormData] = useState({formMateriaInicial});

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        onAdd({
        ...formData,
        });
        
        // Opcional: limpiar formulario tras agregar
        setFormData({formMateriaInicial});
    };

  return (
    <div className="bg-white rounded-[24px] shadow-sm border border-slate-100 overflow-hidden mb-6">
      <div className="p-6 border-b border-slate-50 bg-slate-50/50">
        <h3 className="text-lg font-black text-slate-800 flex items-center gap-2">
          <Plus size={20} className="text-blue-600" />
          Nueva Materia
        </h3>
      </div>

      <form onSubmit={handleSubmit} className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          
          {/* Nombre de la Materia */}
          <div className="col-span-1">
            <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-2 ml-1">
              Nombre de la materia
            </label>
            <div className="relative">
              <BookOpen className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
              <input
                required
                name="nombremateria"
                value={formData.nombremateria}
                onChange={handleChange}
                placeholder="Ej: Cálculo Integral"
                className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-blue-500 transition-all font-medium text-slate-700"
              />
            </div>
          </div>

          {/* Categoría */}
          <div className="col-span-1">
            <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-2 ml-1">
              Categoría
            </label>
            <div className="relative">
              <Tag className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
              <input
                name="categoria"
                value={formData.categoria}
                onChange={handleChange}
                placeholder="Ej: Matemáticas"
                className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-blue-500 transition-all font-medium text-slate-700"
              />
            </div>
          </div>

          {/* Precio Asesoría */}
          <div className="col-span-1">
            <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-2 ml-1">
              Precio Asesoría
            </label>
            <div className="relative">
              <DollarSign className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
              <input
                type="number"
                name="precioAsesoria"
                value={formData.precioAsesoria}
                onChange={handleChange}
                className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-blue-500 transition-all font-medium text-slate-700"
              />
            </div>
          </div>

          {/* Switches de Estado */}
          <div className="col-span-1 flex items-center gap-6 pt-6">
            <label className="flex items-center gap-2 cursor-pointer group">
              <input
                type="checkbox"
                name="materiaActiva"
                checked={formData.materiaActiva}
                onChange={handleChange}
                className="w-5 h-5 rounded-md border-slate-300 text-blue-600 focus:ring-blue-500"
              />
              <span className="text-sm font-bold text-slate-600 group-hover:text-blue-600 transition-colors">Materia Activa</span>
            </label>

            <label className="flex items-center gap-2 cursor-pointer group">
              <input
                type="checkbox"
                name="activo"
                checked={formData.activo}
                onChange={handleChange}
                className="w-5 h-5 rounded-md border-slate-300 text-emerald-600 focus:ring-emerald-500"
              />
              <span className="text-sm font-bold text-slate-600 group-hover:text-emerald-600 transition-colors">Visible</span>
            </label>
          </div>

          {/* Descripción */}
          <div className="col-span-1 md:col-span-2">
            <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-2 ml-1">
              Descripción de la materia
            </label>
            <div className="relative">
              <AlignLeft className="absolute left-3 top-3 text-slate-400" size={18} />
              <textarea
                name="descripcionMateria"
                value={formData.descripcionMateria}
                onChange={handleChange}
                rows="2"
                className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-blue-500 transition-all font-medium text-slate-700"
                placeholder="Detalles sobre el contenido..."
              />
            </div>
          </div>

          {/* Comentario Precio */}
          <div className="col-span-1 md:col-span-2">
            <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-2 ml-1">
              Nota sobre el precio
            </label>
            <div className="relative">
              <AlertCircle className="absolute left-3 top-3 text-slate-400" size={18} />
              <textarea
                name="comentarioPrecioAsesoria"
                value={formData.comentarioPrecioAsesoria}
                onChange={handleChange}
                rows="2"
                className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-blue-500 transition-all font-medium text-slate-700"
                placeholder="Ej: Precio sujeto a complejidad del tema"
              />
            </div>
          </div>
        </div>

        <div className="mt-8 flex justify-end">
          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white font-black uppercase tracking-widest text-xs py-4 px-8 rounded-2xl shadow-lg shadow-blue-200 transition-all flex items-center gap-2 active:scale-95"
          >
            <CheckCircle2 size={18} />
            Guardar Materia
          </button>
        </div>
      </form>

       <ListaMaterias
          materias={materias}
      />

    </div>
  );

}

export default AddMateria
